import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function useCadastreSe() {
    const history = useHistory();
    const location = useLocation();

    const { initialVendedorId, vendedorLocked } = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const raw = params.get('vendedor_id');
        if (raw == null || raw === '') {
            return { initialVendedorId: undefined as number | undefined, vendedorLocked: false };
        }
        const n = Number(raw);
        if (Number.isNaN(n)) {
            return { initialVendedorId: undefined as number | undefined, vendedorLocked: false };
        }
        return { initialVendedorId: n, vendedorLocked: true };
    }, [location.search]);

    const handleSuccess = () => {
        history.push('/cadastre-se/sucesso');
    };

    return { initialVendedorId, vendedorLocked, handleSuccess };
}
